/* eslint-disable class-methods-use-this */
import {TranslationObject} from '@colonist/i18n'
import {SocketDataTypes} from '../../../../shared/SocketDataTypes'
import {LobbyImage} from '@colonist/types'
import {UINotificationController, UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {UICornerNotificationController} from '../ui_corner_notification/UICornerNotificationController'
import {UITopNotificationController} from '../ui_top_notification/UITopNotificationController'
import {NotificationContentType} from '../../../shared/scripts/ui_utils/NotificationUtils'

export class UIWNotificationController extends UINotificationController {
    show(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: (() => void) | undefined, removeAction?: (() => void) | undefined, showCloseButton: boolean = true) {
        UITopNotificationController.show(text, type, buttonText, action, removeAction, showCloseButton)
    }
    showNotification(icon: LobbyImage, text: TranslationObject, duration?: number, action?: () => void, removeAction?: () => void, contentType: NotificationContentType = NotificationContentType.General) {
        UICornerNotificationController.showNotification(icon, text, duration, action, removeAction, undefined, contentType)
    }
    showGames(games: SocketDataTypes.UserGamesData[]) {
        UITopNotificationController.showGames(games)
    }
    removeDisconnectBanners() {
        UITopNotificationController.removeDisconnectBanners()
    }
    removeSocketErrorBanners() {
        UITopNotificationController.removeSocketErrorBanners()
    }
}

